import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { START_GET_SINGLE_REPEAT_ORDER } from "Actions/RepeatOrderAction";
import ContainerWrapper from "./ContainerWrapper";
import OrderCreateAndUpdateMain from "Components/RepeatOrder/OrderCreateAndUpdateMain";
import OrderPadCreateAndUpdateMain from "Components/OrderPad/OrderPadCreateAndUpdateMain";
import RepeatOrderMain from "Components/RepeatOrder/RepeatOrderMain";
// const RepeatOrderMain = React.lazy(() =>
//   import("Components/RepeatOrder/RepeatOrderMain")
// );
// const OrderCreateAndUpdateMain = React.lazy(() =>
//   import("Components/RepeatOrder/OrderCreateAndUpdateMain")
// );
// const OrderPadCreateAndUpdateMain = React.lazy(() =>
//   import("Components/OrderPad/OrderPadCreateAndUpdateMain")
// );

const RepeatOrder = (props) => {
  const { getSingleRepeatOrderAction } = props;
  const navigate = useNavigate();
  const query = new URLSearchParams(window.location.search);

  useEffect(() => {
    if (query.get("actionType") === "edit") {
      if (!query.get("orderId")) {
        navigate("/order");
      }
    }
  }, [query.get("actionType")]);

  return (
    <>
      {/* <ContainerWrapper> */}
      {"order-pad".includes(query.get("orderMethod")) ? (
        <OrderPadCreateAndUpdateMain />
      ) : (
        <>
          {["create", "edit"].includes(query.get("actionType")) ? (
            <OrderCreateAndUpdateMain />
          ) : (
            <RepeatOrderMain />
          )}
        </>
      )}
      {/* </ContainerWrapper> */}
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getSingleRepeatOrderAction: (id) =>
    dispatch({ type: START_GET_SINGLE_REPEAT_ORDER, id }),
});

export default connect(mapStateToProps, mapDispatchToProps)(RepeatOrder);
